import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import { IoIosSearch } from "react-icons/io";
import { fetchDataFromApi } from "../../../utils/api";
import { MyContext } from "../../../App";
import { Link, useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { ClickAwayListener } from "@mui/base";
import { IoSearchOutline } from "react-icons/io5";

const SearchBox = (props) => {
  const [searchFields, setSearchFields] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);

  const context = useContext(MyContext);
  const history = useNavigate();

  const onChangeValue = (e) => {
    setSearchFields(e.target.value);
    if (e.target.value !== "") {
      fetchDataFromApi(`/api/search?q=${e.target.value}`).then((res) => {
        setSearchData(res);
      });
    } else {
      setSearchData([]);
    }
  };

  const searchProducts = () => {
    if (searchFields !== "") {
      setIsLoading(true);
      setSearchData([]);
      fetchDataFromApi(`/api/search?q=${searchFields}`).then((res) => {
        context.setSearchData(res);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
        props.closeSearch();
        history("/search");
      });
    }
  };

  return (
    <>
      <style>{`
        .headerSearch {
          position: relative;
          width: 100%;
          max-width: 400px;
        }
        .searchResults {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          max-height: 300px;
          overflow-y: auto;
          background: #fff;
          border: 1px solid #ddd;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          z-index: 10;
        }
        .searchResults .result {
          padding: 10px;
          display: flex;
          align-items: center;
          cursor: pointer;
          transition: background 0.3s;
        }
        .searchResults .result:hover {
          background: #f9f9f9;
        }
        .searchResults .img img {
          width: 50px;
          height: 50px;
          object-fit: cover;
          border-radius: 5px;
        }
        .searchResults .info {
          flex: 1;
        }
        @media (max-width: 768px) {
          .headerSearch {
            max-width: 100%;
          }
          .searchResults {
            max-height: 200px;
          }
          .searchResults .result {
            padding: 8px;
          }
          .searchResults .img img {
            width: 40px;
            height: 40px;
          }
          .searchResults .info h4 {
            font-size: 14px;
          }
        }
      `}</style>

      <ClickAwayListener onClickAway={() => setSearchData([])}>
        <div className="headerSearch ml-3 mr-3">
          <input
            type="text "
            style={{
              backgroundColor: "black",
            }}
            className="text-sm font-normal text-black bg-grey-200 border border-grey-500 shadow-md rounded-full bprder-zinc-200 px-2.5 py-2 w-full focus:ring-1 focus:ring-green "
            placeholder="Search for products..."
            onChange={onChangeValue}
          />
          <Button onClick={searchProducts}>
            {isLoading === true ? <CircularProgress /> : <IoIosSearch />}
          </Button>

          {/* {searchData?.length > 0 && (
            <div className="searchResults">
              {searchData?.map((item, index) => (
              
                <div key={index} className="d-flex align-items-center result">
                  <div className="img">
                    <Link
                      to={`/product/${item?.id}`}
                      onClick={() => props.closeSearch()} 
                    >
                      <img src={item?.images[0]} className="w-100" alt={item?.name} />
                    </Link>
                  </div>
                  <div className="info ml-3">
                    <Link
                      to={`/product/${item?.id}`}
                      onClick={() => props.closeSearch()} 
                    >
                      <h4 className="mb-1">
                        {item?.name.substr(0, 50) + "..."}
                      </h4>
                    </Link>
                    <span>Rs. {item?.prices[0]?.actualPrice}</span>
                  </div>
                </div>

              ))}
            </div>
          )} */}
          {searchData && (
            <div className="searchResults">
              {Array.isArray(searchData) && searchData.length > 0 ? (
                searchData?.map((item, index) => (
                  <div key={index} className="d-flex align-items-center result">
                    <div className="img">
                      <Link
                        to={`/product/${item?.id}`}
                        onClick={() => {
                          props.closeSearch();
                          setSearchData([]);
                        }}
                      >
                        <img
                          src={item?.images[0]}
                          className="w-100"
                          alt={item?.name}
                        />
                      </Link>
                    </div>
                    <div className="info ml-3">
                      <Link
                        to={`/product/${item?.id}`}
                        onClick={() => {
                          props.closeSearch();
                          setSearchData([]);
                        }}
                      >
                        <h4 className="mb-1">
                          {item?.name.substr(0, 50) + "..."}
                        </h4>
                      </Link>
                      <span>Rs. {item?.prices[0]?.actualPrice}</span>
                    </div>
                  </div>
                ))
              ) : searchFields ? (
                <div className="p-3 text-center text-gray-600">
                  <div className="search-no-results my-2 d-flex items-center justify-center flex-col">
                    <IoSearchOutline
                      style={{
                        fontSize: "2rem",
                        color: "#6c757d",
                        marginBottom: "10px",
                      }}
                    />
                    <p style={{ margin: 0, color: "#6c757d" }}>
                      No search results found
                    </p>
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </ClickAwayListener>
    </>
  );
};

export default SearchBox;
